import React from 'react';
import DocumentsScreenEnhanced from '../../src/screens/documents/DocumentsScreenEnhanced';

export default function DocumentsRoute() {
  return <DocumentsScreenEnhanced />;
}
